import React from 'react'
import styled from 'styled-components';

/*** CORE COMPONENTS ***/

export const Spacer = styled.div`
  height: ${props => (props.times ? props.times : 1) * 20}px;
`

export const Divider = styled.div`
  border-width: ${props => props.height || 1}px;
  height: ${props => (!props.solid ? props.height : 0)}px;
  border-style: ${props => (props.solid ? 'solid' : undefined)};
  border-color: ${props => props.color || undefined};
  width: ${props => (props.width ? `${props.width}px` : '100%')};
`;

/*** BUTTONS ***/

export const Button = styled.div`
  height: 38px;
  min-width: 250px;
  border-radius: 19px;
  border: 1px solid var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;

  ${props =>
    props.disabled &&
    `
    border: 1px solid var(--light-grey);
    background-color: var(--light-grey);
    color: var(--light-black);
    cursor: default;
    `}

  &:hover {
    background-color: var(--white);
    color: var(--accent);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const AccentBorderButton = styled(Button)`
  border: 1px solid var(--accent);
  color: var(--accent);

  ${props =>
    props.disabled &&
    `
    border: 1px solid var(--light-grey);
    background-color: var(--light-grey);
    color: var(--light-black);
    `}

  &:hover {
    background-color: var(--accent);
    color: var(--white);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const AccentButton = styled(Button)`
  border: 1px solid var(--accent);
  background-color: var(--accent);

  ${props =>
    props.disabled &&
    `
    border: 1px solid var(--light-grey) !important;
    background-color: var(--light-grey) !important;
    color: var(--light-black);
    `}

  &:hover {
    background-color: var(--accent);
    color: var(--white);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const WhiteButton = styled(Button)`
  border: 1px solid var(--white);
  background-color: var(--white);
  color: var(--black);

  ${props =>
    props.disabled &&
    `
    border: 1px solid var(--light-grey);
    background-color: var(--light-grey);
    color: var(--light-black);
    `}

  &:hover {
    color: var(--accent);

    ${props =>
      props.disabled &&
      `
      border: 1px solid var(--light-grey);
      background-color: var(--light-grey);
      color: var(--light-black);
      `}
  }
`;

export const TransparentButton = styled(Button)`
  border: none;
  background: none;
  color: var(--black);

  &:hover {
    color: var(--accent);

    ${props =>
      props.disabled &&
      `
      color: var(--light-black);
      `}
  }
`;

export const MiniButton = styled(Button)`
  padding: 0 8px;
  border-radius: 6px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--accent);
  background-color: var(--accent);
  color: var(--white);

  &:hover {
    color: var(--black);

    ${props =>
      props.disabled &&
      `
      color: var(--light-black);
      `}
  }
`;



/*** TEXT ***/
export const H1 = styled.h1`
  font-size: 40px;
  font-weight: bold;

  @media only screen and (min-width: 768px) {
    font-size: 55px;
  }
`

export const H2 = styled.h2`
  font-size: 30px;
  font-weight: bold;

  @media only screen and (min-width: 768px) {
    font-size: 45px;
  }
`

export const H3 = styled.h3`
  font-size: 26px;
  font-weight: bold;

  @media only screen and (min-width: 768px) {
    font-size: 35px;
  }
`

export const H4 = styled.h4`
  font-size: 18px;
  font-weight: bold;

  @media only screen and (min-width: 768px) {
    font-size: 24px;
  }
`


export const LText = styled.span`
  font-size: 16px;

  @media only screen and (min-width: 768px) {
    font-size: 20px;
  }
`;

export const MText = styled.span`
  font-size: 12px;

  @media only screen and (min-width: 768px) {
    font-size: 16px;
  }
`;

export const SText = styled.span`
  font-size: 10px;

  @media only screen and (min-width: 768px) {
    font-size: 12px;
  }
`;

export const SmallHeader = styled(SText)`
  font-weight: bold;
  text-transform: uppercase;
  opacity: 0.6;
`
